export default __webpack_public_path__ + "static/media/Harshit-Thakuria.9e52839a.png";